import { render, staticRenderFns } from "./v-wrapper-catalog.vue?vue&type=template&id=2a18d9e2&"
import script from "./v-wrapper-catalog.vue?vue&type=script&lang=js&"
export * from "./v-wrapper-catalog.vue?vue&type=script&lang=js&"
import style0 from "./v-wrapper-catalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports